import angular from 'angular';

import InventoryOrderHistoryIndependentTabComponent from './inventory-order-history-independet-tab-component';

export default angular
  .module('inventory-order-history-independent-tab', [])
  .component('inventoryOrderHistoryIndependentTab', new InventoryOrderHistoryIndependentTabComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-order-history-independet-tab/inventory-order-history-independet-tab-module.js